<template>
<Popup :width="width" :top="top" :closePopupEvent="closePopupCB">
    <div slot="header">
      <h6 class="login-header">Notifications</h6>
    </div>
    <div class="notification-container">
      <h4 v-if="emptyNotification" class="no-notification">No new notification</h4>
      <div v-if="!emptyNotification" class="notification-slider">
        <div
          class="car-slider"
          :id="`car-slider-notification`">
            <div
              v-for="(notification, i) in notificationList"
              :key="i"
              class="car-slide"
              >
              <div class="notify-container">
                <div class="notify-img-container" v-if="notification.data.image_url">
                  <img  :src="notification.data.image_url" width="100%" height="100%"/>
                </div>                
                <div class="notify-header row">
                  <div class="col-xlg-10 col-lg-10 col-sm-10 col-xs-8 col-md-10">
                    <h2>{{notification.data.title}}</h2>
                  </div>
                  <div class="col-xlg-2 col-lg-2 col-sm-2 col-xs-4 col-md-2">
                    <p
                    class="notify-time"
                    v-if="notification.timestamp">
                    {{parseToAppTime(notification.timestamp)}}
                  </p>
                  </div>
                </div>
                <p>{{notification.data.message}}</p>
                <div v-if="i !== (notificationList.length - 1)" class="hr"></div>
              </div>              
            </div>
        </div>
      </div>
    </div>
  </Popup>
</template>

<script>
import Utility from '@/mixins/Utility';
import { EventBus } from '@/main';
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'Notification',
  data () {
    return {
      width: '45%',
      top: '45%',
      notificationList: null,
      emptyNotification: false
    }
  },
  props: [
    'closePopupCB'
  ],
  computed: {
    ...mapGetters([
      'fcm_notifications'
    ])
  },
  components: {
    Popup : () => import("@/components/Slots/Popup.vue")    
  },
  created () {   
    this.commitFCMNotifications(false)

  },
  mounted() {
    this.getNotificationList()
  },
  methods: {
    ...mapMutations([
      'commitFCMNotifications'
    ]),
    getNotificationList () {
      if (this.fcm_notifications) {
        this.notificationList = [];
        this.notificationList = this.fcm_notifications
      } else {
        this.emptyNotification = true
      } 
    },
    closePopup () {
      // Hide the popup
      this.closePopupCB();
    }
  },
  mixins: [ Utility ]

}
</script>

<style lang="scss" scoped>
@import '~sass/modules/variables';

.notification-container{
  padding: 10px;
}
.notification-slider{
  padding: 10px 0;
  // margin: 0 5%;
  // padding-bottom: 20px;
}
.notification-slide-controls {
  img {
    width: 35px;
  }
  .btn-slide-controls {
    background-color: transparent;
    border: 0;
    cursor: pointer;
    &:disabled{
      cursor: not-allowed;
      opacity: 0.3;
    }    
  }
  .prev{
    position: absolute;
    z-index: 100;
    top: 55%;
    left: 1%;
  }
  .next{
    position: absolute;
    right: 1%;
    top: 55%;
    z-index: 100;
  }
}
#car-slider-notification{
  max-height: 450px;
  overflow: auto;
   /* width */
  &::-webkit-scrollbar {
    width: 6px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    //box-shadow: inset 0 0 5px grey; 
    border-radius: 15px;
  }
  
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #b9bcb9; 
    border-radius: 15px;
  }
}
.notify-container{
  // min-height: 100px;
  margin: 2%;
  .notify-header{
    margin: 1% 0;
    div {
      padding: 0;
    }
    h2{
      color: #000000;
      font-size: 18px;
      letter-spacing: 1px;
      font-family: "ProximanovaBold";
      word-break: break-word;
    }
    p{
      color: #000000;
      font-size: 15px;
      letter-spacing: 1px;
      font-family: "ProximanovaRegular";
      text-align: end;
    }
  }
  p{
    color: #000000;
    font-size: 15px;
    letter-spacing: 1px;
    font-family: "ProximanovaRegular";
    word-break: break-word;
  }
  .notify-img-container{
    width: 100%;
    height: 300px;
    margin-bottom: 10px;
    img {
      border-radius: 10px;
    }
  }
}
.hr{
  width: 100%;
  height: 2px;
  margin: 4% 0;
  border-bottom: 1px solid #9090904d;
}
.no-notification{
  text-align: center;
  color: #000000;
  font-size: 20px;
  letter-spacing: 1px;
  font-family: "ProximanovaRegular";
  word-break: break-word;
}
/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .notify-container {
    .notify-time{
      // text-align: start !important;
      text-align: end;
    }
  }
} 

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {} 

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {} 

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {} 

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {}
</style>



// WEBPACK FOOTER //
// src/components/Popups/Notification.vue